import React from "react";
import { captureException } from "./telemetry";

type Props = {
  children: React.ReactNode;
  fallback: React.ReactNode;
  apiBaseURL: string;
  linkToken: string;
};

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, _info: React.ErrorInfo) {
    if (
      process.env.REACT_APP_MERGE_ENV === "PRODUCTION" ||
      process.env.REACT_APP_MERGE_ENV === "DEVELOP"
    ) {
      captureException(error);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
